// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__BBCH8","ranges":"BmiRanges_ranges__16LF-"};